import { render, staticRenderFns } from "./assetLedgerRelatedResource.vue?vue&type=template&id=bb869e7a&scoped=true"
import script from "./assetLedgerRelatedResource.vue?vue&type=script&lang=js"
export * from "./assetLedgerRelatedResource.vue?vue&type=script&lang=js"
import style0 from "./assetLedgerRelatedResource.vue?vue&type=style&index=0&id=bb869e7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb869e7a",
  null
  
)

export default component.exports